import React from 'react';
import {Tooltip, TooltipHandler} from '@genestack/ui';
import * as PopperJS from '@popperjs/core';

export interface TooltipOptions {
    tooltipClassname?: string;
    portalContainer?: Element;
    placement?: PopperJS.Placement;
}

const defaultOptions: TooltipOptions = {};

export function wrapWithTooltip(el: React.ReactElement, tooltip: string, options?: TooltipOptions) {
    const {placement, portalContainer, tooltipClassname} = options ? options : defaultOptions;

    return (
        <TooltipHandler
            tooltip={
                <Tooltip
                    placement={placement}
                    className={tooltipClassname}
                    portalContainer={portalContainer}
                >
                    {tooltip}
                </Tooltip>
            }
        >
            <span>{el}</span>
        </TooltipHandler>
    );
}
